import { store } from '../core/store.js';

let lenisInstance = null;
let rafId = null;

export function initSmoothScroll() {
    if (typeof window.Lenis === 'undefined') return;

    function startLenis() {
        if (!lenisInstance) {
            lenisInstance = new window.Lenis({
                lerp: 0.15,
                smoothWheel: true,
                wheelMultiplier: 0.9,
            });

            function raf(time) {
                if (lenisInstance) {
                    lenisInstance.raf(time);
                    rafId = requestAnimationFrame(raf);
                }
            }
            rafId = requestAnimationFrame(raf);
            console.log("Lenis Smooth Scroll started");
        }
    }

    function stopLenis() {
        if (lenisInstance) {
            lenisInstance.destroy();
            lenisInstance = null;
            if (rafId) {
                cancelAnimationFrame(rafId);
                rafId = null;
            }
            console.log("Lenis Smooth Scroll stopped");
        }
    }

    // Inicializar solo si no estamos en editorMode
    if (!store.get('editorMode')) {
        startLenis();
    }

    // Exponer para que tools.js pueda activarlo/desactivarlo
    window.toggleSmoothScroll = (isEditorMode) => {
        if (isEditorMode) {
            stopLenis();
        } else {
            startLenis();
        }
    };
}
